export default __webpack_public_path__ + "static/media/ukg.b2cda074.jpg";